(function () {
  angular.module('binky.core.number-format-js', []);
})();
